import { render, staticRenderFns } from "./ToolbarSettings.vue?vue&type=template&id=50dcce98&scoped=true"
import script from "./ToolbarSettings.vue?vue&type=script&lang=js"
export * from "./ToolbarSettings.vue?vue&type=script&lang=js"
import style0 from "./ToolbarSettings.vue?vue&type=style&index=0&id=50dcce98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcce98",
  null
  
)

export default component.exports